/**
 * @generated SignedSource<<cfaea0358d561c7fd958461d5b6a9c83>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventAgentLost_event$fragmentType: FragmentType;
export type JobEventAgentLost_event$data = {|
  +timestamp: any,
  +$fragmentType: JobEventAgentLost_event$fragmentType,
|};
export type JobEventAgentLost_event$key = {
  +$data?: JobEventAgentLost_event$data,
  +$fragmentSpreads: JobEventAgentLost_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAgentLost_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "c960465a887fe4a3fe9b65a7fb5cc94a";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventAgentLost_event$fragmentType,
  JobEventAgentLost_event$data,
>*/);
